
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import VerifyAccount from "./pages/VerifyAccount";

import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./Layout/DashboardLayout";

import Dashboard from "./pages/Dashboard";

import OrganizationList from "./pages/OrganizationList";
import CreateOrganization from "./pages/CreateOrganization";
import UsersList from "./pages/UsersList";
import CreateUser from "./pages/CreateUsers";
import OrganizationDetails from "./pages/OrganizationDetails";
import CreateAgent from "./pages/CreateAgent";
import AgentsList from "./pages/AgentsList";
import AgentEarnings from "./pages/AgentEarnings";
import AgentMerchantsDetails from "./pages/AgentMerchantsDetails";
import MerchantProfile from "./pages/MerchantProfile";
import MerchantTransactions from "./pages/MerchantTransactions ";
import Transactions from "./pages/Transactions";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";

function App() {
  return (
    <Routes>
      {/* Login Page */}
      <Route path="/" element={<Login />} />
      <Route path="/verify-account" element={<VerifyAccount />} />

      {/* Protected Dashboard Layout */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        {/* Nested pages */}
        <Route index element={<Dashboard />} />
       
  
         <Route path="organizationlist" element={<OrganizationList />} />
         <Route path="organization" element={<CreateOrganization />} />
         <Route path="userslist" element={<UsersList />} />
         <Route path="users" element={<CreateUser />} />
         <Route path="OrganizationDetails" element={<OrganizationDetails />} />
         <Route path="agentslist" element={<AgentsList />} />
         
         
         <Route path="agent-earnings" element={<AgentEarnings />} />
          <Route path="merchantsdetails" element={<AgentMerchantsDetails />} />
<Route path="merchantprofile" element={<MerchantProfile />} />
<Route path="merchant-transactions" element={<MerchantTransactions />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
        {/* Fallback redirect */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Route>
    </Routes>
  );
}

export default App;
